import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "subtitleDashboard" }
const _hoisted_2 = {
  class: "subtitleDashboard",
  style: {"font-size":"24px !important"}
}
const _hoisted_3 = { class: "mt-8 mb-2 text-left" }
const _hoisted_4 = {
  key: 1,
  class: "text-left"
}

import { ref, onMounted, onBeforeUnmount } from 'vue';

/********************************
 ********** COMPONENTS **********
 *******************************/
import IEOCardComponent from '@/components/SmartLink/dashboard/IEOCardComponent.vue';
import TimeLineAlerts from '@/components/SmartLink/dashboard/TimeLineAlerts.vue';

/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
import { useDisplay } from 'vuetify';
import { useI18n } from 'vue-i18n';
import { getAlarmRecurrent } from '@/services/Smartlink/Principal';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { LABELS } from '@/constants/labels';



export default /*@__PURE__*/_defineComponent({
  __name: 'MessageComponent',
  setup(__props) {

const store = useStore();

/********************************
 ************ VUETIFY ***********
 *******************************/
const { mdAndDown, smAndDown } = useDisplay();

/********************************
 ************ I18N **************
 *******************************/
const { t } = useI18n()

/********************************
 *********** SERVICES ***********
 *******************************/
const allAlertItems     = ref([]);
const showAlertTimeLine = ref(false);
const heightTimeLine    = ref(492);

/**
 * Captura los valores de la API: "getAlarmRecurrentToDashBoard"
 */
const getAlarmToDashBoard = async () => {

    showAlertTimeLine.value = false;
    allAlertItems.value = [];

    const allData = await getAlarmRecurrent()
    
    if( allData.status === 400 ){
        showAlertTimeLine.value = allData.showGraphs
        store.commit('showSnackBar', {type: LABELS.error, msg: t('snackbar.errorApis'), valor : true});
    }
    if( allData.status === 200 ){
        showAlertTimeLine.value = allData.showGraphs
        allAlertItems.value = allData.data
    }
    
}


let intervaloId:any = null;

async function iniciarVista() {
    intervaloId = setInterval(async() => {
        await getAlarmToDashBoard();
    }, 60000);
}

async function cambiarDeVista() {
    if (intervaloId) {
        clearInterval(intervaloId);
        intervaloId = null; // Buena práctica
    }    
}


onMounted(async() => {
    iniciarVista();
    await getAlarmToDashBoard();
})

onBeforeUnmount(() => {
    cambiarDeVista();
});


return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, {
    class: _normalizeClass(_unref(mdAndDown) ? 'ma-0 mt-3' : 'ma-0'),
    justify: "center"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        cols: "12",
        class: "pa-0",
        "align-self": "center"
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_1, [
            _createTextVNode(_toDisplayString(_unref(t)('labels.ociTitle')) + " ", 1),
            _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(t)('labels.oci')), 1)
          ]),
          _createVNode(IEOCardComponent, { width: 330 }),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('labels.msn')), 1),
          (showAlertTimeLine.value)
            ? (_openBlock(), _createBlock(TimeLineAlerts, {
                key: 0,
                class: "text-left",
                "array-items": allAlertItems.value,
                width: _unref(smAndDown) ? 400 : 315,
                height: heightTimeLine.value,
                isRecurrent: true
              }, null, 8, ["array-items", "width", "height"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_unref(t)('noAlertsAlarmRecurren')), 1))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})